
import { useState } from "react";
import { PostTypeSelector } from "./PostTypeSelector";
import { CreatePost } from "./CreatePost";
import { CreateCastPost } from "./CreateCastPost";

interface PostCreatorProps {
  onBack: () => void;
}

type PostCreatorState = "selector" | "video" | "cast";

export const PostCreator = ({ onBack }: PostCreatorProps) => {
  const [currentState, setCurrentState] = useState<PostCreatorState>("selector");

  const handleSelectVideo = () => {
    setCurrentState("video");
  };

  const handleSelectCast = () => {
    setCurrentState("cast");
  };

  const handleBackToSelector = () => {
    setCurrentState("selector");
  };

  switch (currentState) {
    case "video":
      return <CreatePost onBack={handleBackToSelector} />;
    case "cast":
      return <CreateCastPost onBack={handleBackToSelector} />;
    default:
      return (
        <PostTypeSelector 
          onSelectVideo={handleSelectVideo}
          onSelectCast={handleSelectCast}
          onBack={onBack}
        />
      );
  }
};
